import React from 'react';
import { DateFormatter } from '.';
import { useInternationalization } from '@progress/kendo-react-intl';

const GridDateCell = (props) => {
  const intlService = useInternationalization();
  const value = props.dataItem[props.field]
    ? DateFormatter(new Date(props.dataItem[props.field]), intlService)
    : '';
  return (
    <td className={props.className}>{value.replaceAll('-', '\u2011')}</td>
  );
};

export default GridDateCell;
